export default __webpack_public_path__ + "static/media/icons8-love-time-100.444ffb5e.svg";